// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { OrderTif, OrderTifMap } from '@shared/utils/Trading/OrderTifEnum';
import { ErrorInformationStorage } from '../ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
export class TerceraLineStyleComboBoxUtils {
    static getLocalizedTIF(tif, date) {
        try {
            const tifLocName = Resources.getResource(OrderTifMap[tif]);
            return tif === OrderTif.GTD && date ? tifLocName + ' ' + DateTimeUtils.FormatToDate(date) : tifLocName;
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
        }
    }
    static cretaComboItem(tif, date) {
        const res = {};
        res.date = date;
        res.tif = {};
        res.tif.value = tif;
        res.tif.text = TerceraLineStyleComboBoxUtils.getLocalizedTIF(tif, date);
        return res;
    }
}
